import {EChannelType, TItemId} from 'src/constants';
import {TBankDetails} from 'src/containers/User';

export enum EUserCompanyProfileTabs {
  PAYMENT = 'payment',
  LICENSE = 'license',
  REQUISITES = 'requisites',
  PRICING = 'pricing',
  MAILINGS = 'mailings',
}

export const COMPANY_PROFILE_TABS = Object.values(EUserCompanyProfileTabs);

export enum ETemporaryBlockedTypes {
  BROADCASTS = 'BROADCASTS',
  TEMPLATES = 'TEMPLATES',
  CHANNELS = 'CHANNELS',
  CASCADES = 'CASCADES',
  OTHER = 'OTHER',
}

export type TGeneratePaymentLinkResponse = {downloadLink: string; amount: number; email: string};
export type TGeneratePaymentLinkPayload = {
  tenantId?: TItemId;
  bankDetails?: TBankDetails;
  amount: number;
};

export enum EMailingsCategory {
  CHANNELS_EMAIL_NOTIFICATIONS = 'CHANNELS_EMAIL_NOTIFICATIONS',
  TEMPLATES_EMAIL_NOTIFICATIONS = 'TEMPLATES_EMAIL_NOTIFICATIONS',
  LICENSE_EMAIL_NOTIFICATIONS = 'LICENSE_EMAIL_NOTIFICATIONS',
  PAYKEEPER_EMAIL_NOTIFICATIONS = 'PAYKEEPER_EMAIL_NOTIFICATIONS',
  STRIPE_EMAIL_NOTIFICATIONS = 'STRIPE_EMAIL_NOTIFICATIONS',
  BALANCE_EMAIL_NOTIFICATIONS = 'BALANCE_EMAIL_NOTIFICATIONS',
}

export enum EMailingSubcategory {
  // CHANNELS_EMAIL_NOTIFICATIONS
  REGISTRATION_OK_NOTIFY_CHANNEL_EMAIL = 'REGISTRATION_OK_NOTIFY_CHANNEL_EMAIL',
  REGISTRATION_VK_NOTIFY_CHANNEL_EMAIL = 'REGISTRATION_VK_NOTIFY_CHANNEL_EMAIL',
  REGISTRATION_WHATSAPP_CHANNEL_EMAIL = 'REGISTRATION_WHATSAPP_CHANNEL_EMAIL',
  RESTRICTIONS_WABA_EMAIL = 'RESTRICTIONS_WABA_EMAIL',
  CHANGE_QUALITY_WHATSAPP_CHANNEL_EMAIL = 'CHANGE_QUALITY_WHATSAPP_CHANNEL_EMAIL',
  REGISTRATION_VIBER_CHANNEL_EMAIL = 'REGISTRATION_VIBER_CHANNEL_EMAIL',
  REGISTRATION_SMS_CHANNEL_EMAIL = 'REGISTRATION_SMS_CHANNEL_EMAIL',
  // TEMPLATES_EMAIL_NOTIFICATIONS
  REGISTRATION_VK_NOTIFY_TEMPLATE_EMAIL = 'REGISTRATION_VK_NOTIFY_TEMPLATE_EMAIL',
  REGISTRATION_OK_NOTIFY_TEMPLATE_EMAIL = 'REGISTRATION_OK_NOTIFY_TEMPLATE_EMAIL',
  REGISTRATION_SMS_TEMPLATE_EMAIL = 'REGISTRATION_SMS_TEMPLATE_EMAIL',
  REGISTRATION_VIBER_TEMPLATE_EMAIL = 'REGISTRATION_VIBER_TEMPLATE_EMAIL',
  REGISTRATION_WHATSAPP_TEMPLATE_EMAIL = 'REGISTRATION_WHATSAPP_TEMPLATE_EMAIL',
  CHANGE_WHATSAPP_TEMPLATE_EMAIL = 'CHANGE_WHATSAPP_TEMPLATE_EMAIL',
  DISABLE_WHATSAPP_TEMPLATE_EMAIL = 'DISABLE_WHATSAPP_TEMPLATE_EMAIL',
  // LICENSE_EMAIL_NOTIFICATIONS
  SMS_LICENSE_STATUS_EMAIL = 'SMS_LICENSE_STATUS_EMAIL',
  NOT_ENOUGH_FUNDS_FOR_SMS_LICENSE_EMAIL = 'NOT_ENOUGH_FUNDS_FOR_SMS_LICENSE_EMAIL',
  VIBER_LICENSE_STATUS_EMAIL = 'VIBER_LICENSE_STATUS_EMAIL',
  NOT_ENOUGH_FUNDS_FOR_VIBER_LICENSE_EMAIL = 'NOT_ENOUGH_FUNDS_FOR_VIBER_LICENSE_EMAIL',
  WHATSAPP_LICENSE_STATUS_EMAIL = 'WHATSAPP_LICENSE_STATUS_EMAIL',
  NOT_ENOUGH_FUNDS_FOR_WHATSAPP_LICENSE_EMAIL = 'NOT_ENOUGH_FUNDS_FOR_WHATSAPP_LICENSE_EMAIL',
  // PAYKEEPER_EMAIL_NOTIFICATIONS
  PAYKEEPER_REFUND_EMAIL = 'PAYKEEPER_REFUND_EMAIL',
  // STRIPE_EMAIL_NOTIFICATIONS
  STRIPE_TOP_UP_BALANCE_EMAIL = 'STRIPE_TOP_UP_BALANCE_EMAIL',
  // BALANCE_EMAIL_NOTIFICATIONS
  OVERDRAFT_STATUS_EMAIL = 'OVERDRAFT_STATUS_EMAIL',
  BALANCE_DROPPED_BELOW_THRESHOLD_EMAIL = 'BALANCE_DROPPED_BELOW_THRESHOLD_EMAIL',
}

export type TMailing = {
  subcategory: EMailingSubcategory;
  channelType?: EChannelType;
  settings: {recipients: string[]};
};

export type TMailingCategory = {
  category: EMailingsCategory;
  subcategories: TMailing[];
};
